<div [innerHTML]="formData.preSelectStepDescription | markdown" class="step-description"></div>

<mat-divider></mat-divider>

<div [innerHTML]="formData.categoryDescription | markdown" class="step-description"></div>

<app-chip-selector
  [allItems]="filterValues.categories"
  [label]="formData.categoryLabel | formData"
  [addLabel]="formData.categoryAddLabel | formData"
  (selectionChanged)="categoriesChanged($event)"
  [initialSelection]="initialValues.categories"
></app-chip-selector>

<div [innerHTML]="formData.customerDescription | markdown" class="step-description"></div>
<app-chip-selector
  [allItems]="filterValues.customers"
  [label]="formData.customerLabel | formData"
  [addLabel]="formData.customerAddLabel | formData"
  (selectionChanged)="customersChanged($event)"
  [initialSelection]="initialValues.customers"
></app-chip-selector>

<div [innerHTML]="formData.roleDescription | markdown" class="step-description"></div>
<app-chip-selector
  [allItems]="filterValues.roles"
  [label]="formData.roleLabel | formData"
  [addLabel]="formData.roleAddLabel | formData"
  (selectionChanged)="rolesChanged($event)"
  [initialSelection]="initialValues.roles"
></app-chip-selector>

<div [innerHTML]="formData.keywordDescription | markdown" class="step-description"></div>
<app-chip-selector
  [allItems]="filterValues.keywords"
  [label]="formData.keywordLabel | formData"
  [addLabel]="formData.keywordAddLabel | formData"
  (selectionChanged)="keywordsChanged($event)"
  [initialSelection]="initialValues.keywords"
></app-chip-selector>

<div>
  <button mat-stroked-button matStepperPrevious>{{ formData.buttonLabelBack }}</button>
  <button mat-stroked-button matStepperNext>{{ formData.buttonLabelNext }}</button>
</div>
